import { get, post, put, upload, uploadPut, del, patch } from '@api/request';

export async function fetchCurrentAppealYear(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchAppeals(
  { appealsService },
  authenticationToken,
  {
    pageSize = 0,
    page,
    payload,
    sortField,
    sortDirection,
    sortField1,
    sortDirection1,
    sortField2,
    sortDirection2,
    sortField3,
    sortDirection3,
  },
) {
  let url = `${appealsService}/prodigyappeals/appeals/search?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (sortField1 && sortDirection1) {
    url += `&sortField1=${sortField1}&sortDirection1=${sortDirection1}`;
  }

  if (sortField2 && sortDirection2) {
    url += `&sortField2=${sortField2}&sortDirection2=${sortDirection2}`;
  }

  if (sortField3 && sortDirection3) {
    url += `&sortField3=${sortField3}&sortDirection3=${sortDirection3}`;
  }

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function searchAppealsExport(
  { appealsService },
  authenticationToken,
  {
    payload,
    sortField,
    sortDirection,
    sortField1,
    sortDirection1,
    sortField2,
    sortDirection2,
    sortField3,
    sortDirection3,
  },
) {
  let url = `${appealsService}/prodigyappeals/appeals/search`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (sortField1 && sortDirection1) {
    url += `&sortField1=${sortField1}&sortDirection1=${sortDirection1}`;
  }

  if (sortField2 && sortDirection2) {
    url += `&sortField2=${sortField2}&sortDirection2=${sortDirection2}`;
  }

  if (sortField3 && sortDirection3) {
    url += `&sortField3=${sortField3}&sortDirection3=${sortDirection3}`;
  }

  const { body } = await post(authenticationToken, url, payload, {
    outputType: 'bytearray',
  });

  const blob = new Blob([body], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'export.xlsx';

  link.click();
  window.URL.revokeObjectURL(link.href);
}

export async function searchAppealsStandalone(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const downloadAppealFile = async (
  { appealsService },
  authenticationToken,
  { s3ID },
) => {
  const url = `${appealsService}/prodigyappeals/appeals/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchSearchResultsConfig(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/config/appealssearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsUpdateConfig(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsupdate/config`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCodeFile(
  { appraisalService, appealsService },
  authenticationToken,
  { year, type, name },
) {
  if (type === 'docketType' && name === 'Informal') {
    const url = `${appealsService}/prodigyappeals/appealdockets?docketType=Informal`;
    const { body } = await get(authenticationToken, url);
    if (body?.results?.length) {
      body.results = body.results.map((r) => {
        return {
          codeName: r.docketID,
          codeDescription: r.docketDescription,
          customDescription: `${r.docketDt} (${r.docketDescription})`,
        };
      });
    }
    return body;
  }
  if (type === 'Property' && name === 'Exemptions') {
    const url = `${appealsService}/assessment/exemptions/${year}`;
    const { body } = await get(authenticationToken, url);
    if (body?.results?.length) {
      body.results = body.results.map((r) => {
        return {
          codeName: r.exemptionCode,
          codeDescription: r.exemptionDesc,
        };
      });
    }
    return body;
  }
  const url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}${
    year ? `&year=${year}` : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/user/appraisal/byattribute/Appraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchUsers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/user/appraisal/byattribute/All`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStatistics({ appealsService }, authenticationToken) {
  const url = `${appealsService}/prodigyappeals/statistics?userToShow=all`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsHeader(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/header`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealGeneralInfo(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/general`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealGeneralInfo(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/general`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealsSummary(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/summary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealsSummary(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/summary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealReasons(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/reasons`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealReasons(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/reasons`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealTags(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealTags(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchClaimantInfo(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/claimant`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAffidavitInfo(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/taxpayeraffidavit/files`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertFile(
  { appealsService },
  authenticationToken,
  { appealId, payload, typeName },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/${typeName}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function setFileType(
  { appealsService },
  authenticationToken,
  { appealId, payload, s3Id },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/convertfile/${String(
    s3Id,
  ).replaceAll('#', '%23')}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteFile(
  { appealsService },
  authenticationToken,
  { appealId, s3Id, payload, typeName },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/${typeName}/file/${String(
    s3Id,
  ).replaceAll('#', '%23')}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const downloadFile = async (
  { appealsService },
  authenticationToken,
  { appealId, s3Id, typeName },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/${typeName}/file/${String(
    s3Id,
  ).replaceAll('#', '%23')}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchDueDiligence(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/duediligence`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateDueDiligence(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/duediligence`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateDueDiligenceComments(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/duediligencecomments`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealInformal(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/informal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealInformal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/informal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPriorYearComments(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/prioryears`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function startInformal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/informal/start`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function finishInformal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/informal/finish`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealFormal(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/formal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealFormal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/formal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function patchAppealFormal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/formal`;
  const { body } = await patch(authenticationToken, url, payload);
  return body;
}

export async function startFormal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/formal/start`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function finishFormal(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/formal/finish`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealFinalValues(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/finalvalues`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealFinalValues(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/appealfinalvaluesdistribute`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function finalizeAppealFinalValues(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchGlobalDocuments(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeal/globaldocuments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsPresentationDocuments(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentationdocuments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function setPresentationDocumentOrder(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentationdocumentorder`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function uploadMassCreateFiles(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/fileupload`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function insertPresentationDocument(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentationdocuments`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function insertPresentationDocumentByS3(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/addmarketareaevidence`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function insertPresentationDocumentGenerate(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentationdocumentsgenerate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const downloadGlobalDocument = async (
  { appealsService },
  authenticationToken,
  { documentId },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/globaldocument/${documentId}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${documentId}.pdf`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchAppealsPresentation(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentation`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteAppealsPresentation(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentation/delete`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export const downloadPresentationFile = async (
  { appealsService },
  authenticationToken,
  { appealId, isDownload = true },
) => {
  const rand = [...Array(3)].map(() => ((Math.random() * 36) | 0).toString(36))
    .join``;
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentation/file?${rand}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('cache-control', 'no-store');

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      if (isDownload) {
        anchor.download = `Case ${appealId} District Presentation.pdf`;
      } else {
        anchor.target = '_blank';
      }
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const viewPresentationFile = async (
  { appealsService },
  authenticationToken,
  { appealId },
) => {
  const rand = [...Array(3)].map(() => ((Math.random() * 36) | 0).toString(36))
    .join``;
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentation/file?${rand}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('cache-control', 'no-store');

  const response = await fetch(url, { headers });
  const blobby = await response.blob();

  return blobby;
};

export const downloadPresentationDocument = async (
  { appealsService },
  authenticationToken,
  { documentId, filename },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/presentationdocument/${documentId}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      if (filename) {
        anchor.download = `${filename}.pdf`;
      }
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchPresentationFile(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/presentation/fileurl`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function publishAppealsPresentation(
  { appealsService },
  authenticationToken,
  { appealId, preview },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/publish`;
  if (!preview) {
    const { body } = await post(authenticationToken, url, { preview });
    return body;
  }

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    headers,
    method: 'POST',
    body: JSON.stringify({ preview: true }),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.target = '_blank';
      anchor.click();
      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function deleteAppealsPresentationDocument(
  { appealsService },
  authenticationToken,
  { documentId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/presentationdocument/${documentId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelStatistics(
  { appealsService },
  authenticationToken,
  { beginDate, endDate },
) {
  const url = `${appealsService}/prodigyappeals/appealpanels/statistics?beginDt=${beginDate}&endDt=${endDate}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelStatisticsDetail(
  { appealsService },
  authenticationToken,
  { panelID, beginDate, endDate },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/statistics?beginDt=${beginDate}&endDt=${endDate}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsStaff(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/staff`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getAppealIncomeActual(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/commercialevidencepackets/incomeworksheets/directcapactuals/${appealId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getAppealIncomeModel(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/commercialevidencepackets/incomeworksheets/directcapmodel/${appealId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealsStaff(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/staff`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealsStaff(
  { appealsService },
  authenticationToken,
  { staffId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/staff/${staffId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAppealDocuments(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/documents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealDocument(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/documents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealDocument(
  { appealsService },
  authenticationToken,
  { documentId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/document/${documentId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealDocument(
  { appealsService },
  authenticationToken,
  { documentId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/document/${documentId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function insertAppealDocFile(
  { appealsService },
  authenticationToken,
  { documentId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/document/${documentId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealDocFile(
  { appealsService },
  authenticationToken,
  { documentId, s3Id, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/document/${documentId}/file/${s3Id}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const downloadAppealDocFile = async (
  { appealsService },
  authenticationToken,
  { documentId, s3Id },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/document/${documentId}/file/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function insertAppeal(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchCasePrep(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/caseprep`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateCasePrep(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/caseprep`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPanels({ appealsService }, authenticationToken) {
  const url = `${appealsService}/prodigyappeals/appealpanels`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchConfigurationByAppeal(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/commercialevidencepackets/configuration/forappeal/${appealID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBoardMembers(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/boardmembers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchActivity(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/activity`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealBoardMembers(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appealboardmembers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealBoardMember(
  { appealsService },
  authenticationToken,
  { memberId },
) {
  const url = `${appealsService}/prodigyappeals/appealboardmember/${memberId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function codeFileOfficerPositions(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Board Member Officer Positions`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function codeFileRoles({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Board Member Roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function codeFilePreferredCommunication(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Preferred Communication`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealBoardMember(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealboardmembers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealBoardMember(
  { appealsService },
  authenticationToken,
  { boardMemberId },
) {
  const url = `${appealsService}/prodigyappeals/appealboardmember/${boardMemberId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateAppealBoardMember(
  { appealsService },
  authenticationToken,
  { boardMemberId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealboardmember/${boardMemberId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPanel(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelRoles(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Panel Roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealPanel(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanels`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealPanel(
  { appealsService },
  authenticationToken,
  { panelID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealPanel(
  { appealsService },
  authenticationToken,
  { panelID },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelBoardMember(
  { appealsService },
  authenticationToken,
  { panelId, appealBoardMemberId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/boardmember/${appealBoardMemberId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealPanelBoardMember(
  { appealsService },
  authenticationToken,
  { panelId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/boardmembers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealPanelBoardMember(
  { appealsService },
  authenticationToken,
  { panelId, appealBoardMemberId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/boardmember/${appealBoardMemberId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealPanelBoardMember(
  { appealsService },
  authenticationToken,
  { panelId, appealMemberId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/boardmember/${appealMemberId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAppealStaffRoles(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=CAD Staff Roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelCadStaffs(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/cadstaff`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelCadStaff(
  { appealsService },
  authenticationToken,
  { panelId, appealStaffId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/cadstaff/${appealStaffId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealPanelCadStaff(
  { appealsService },
  authenticationToken,
  { panelId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/cadstaff`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealPanelCadStaff(
  { appealsService },
  authenticationToken,
  { panelId, appealStaffId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/cadstaff/${appealStaffId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealPanelCadStaff(
  { appealsService },
  authenticationToken,
  { panelId, appealStaffId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/cadstaff/${appealStaffId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAppealDecisionAuthority(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Decision Authority`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealDecisionCode(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Decision`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealDecisionReason(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Decision Reason`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealDecisionStatus(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealRecommendationReason(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Recommendation Reason`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealSearchParams(
  { appealsService },
  authenticationToken,
  { userName },
) {
  const queryParam = userName ? `?userName=${userName}` : '';
  const url = `${appealsService}/prodigyappeals/appeals/searchparameters${queryParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealSearchParam(
  { appealsService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appealsService}/prodigyappeals/appeals/searchparameter/${searchParamID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealSearchParam(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/searchparameters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealSearchParam(
  { appealsService },
  authenticationToken,
  { searchParamID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/searchparameter/${searchParamID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function duplicateAppealSearchParam(
  { appealsService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appealsService}/prodigyappeals/appeals/searchparameter/${searchParamID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function deleteAppealSearchParam(
  { appealsService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appealsService}/prodigyappeals/appeals/searchparameter/${searchParamID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAppealRecommendations(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/recommendations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRecommendationValues(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/recommendationvalues`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertRecommendation(
  { appealsService },
  authenticationToken,
  { appealID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/recommendations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchRecommendation(
  { appealsService },
  authenticationToken,
  { recommendationID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function acceptRecommendation(
  { appealsService },
  authenticationToken,
  { recommendationID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}/accept`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function cancelRecommendation(
  { appealsService },
  authenticationToken,
  { recommendationID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}/cancel`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertRecommendationFile(
  { appealsService },
  authenticationToken,
  { recommendationID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}/documents`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function updateRecommendationFile(
  { appealsService },
  authenticationToken,
  { recommendationID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}/documents`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const downloadRecommendationFile = async (
  { appealsService },
  authenticationToken,
  { recommendationID, s3ID },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}/document/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function deleteRecommendationFile(
  { appealsService },
  authenticationToken,
  { recommendationID, s3ID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/recommendation/${recommendationID}/document/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchStatusCodes(
  { appealsService },
  authenticationToken,
  params = { activeOnly: undefined },
) {
  let url = `${appealsService}/prodigyappeals/appealstatusconfig`;

  if (params.activeOnly !== undefined) {
    url += `?activeOnly=${params.activeOnly}`;
  }

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteStatusCode(
  { appealsService },
  authenticationToken,
  { appealStatus },
) {
  const url = `${appealsService}/prodigyappeals/appealstatusconfig/${appealStatus}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function appealStatusConfigState(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appealstatusconfigstate`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function appealModuleReports(
  { reportService },
  authenticationToken,
) {
  const url = `${reportService}/reporting/reportsbymodule/Prodigy Appeals`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealStatus(
  { appealsService },
  authenticationToken,
  { appealStatusId },
) {
  const url = `${appealsService}/prodigyappeals/appealstatusconfig/${appealStatusId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealStatusConfig(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealstatusconfig`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealStatusConfig(
  { appealsService },
  authenticationToken,
  { appealStatusId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealstatusconfig/${appealStatusId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const downloadPortalActivityFile = async (
  { appealsService },
  authenticationToken,
  { activityId, s3Id },
) => {
  const url =
    `${appealsService}/prodigyappeals/appealactivity/` +
    `${activityId}/file/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function generateIndividualLetter(
  { appealsService },
  authenticationToken,
  { appealID, payload, reportName },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/letter`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${reportName}.pdf`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function massGenerateFinalLettersValidateAppealList(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massgenerateletters/validateappeals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massFinalizeValidateAppealList(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massfinalize/validateappeals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massReopenValidateAppealList(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massreopen/validateappeals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massFinalizeValidateAppealListForRollCorrection(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massfinalize/validateappealsforrollcorrection`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massFinalizeAppealList(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massfinalize`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massFinalizeAppealListStatus(
  { appealsService },
  authenticationToken,
  { massFinalizeId },
) {
  const url = `${appealsService}/prodigyappeals/massfinalize/${massFinalizeId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function massClearFormalHearingDate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsclearformalhearing`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massClearFormalArrivalTime(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsclearformalarrival`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massAppealProtesterUpdate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealprotesterupdate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massClearInformalHearingDate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsclearinformalhearing`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massClearInformalArrivalTime(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsclearinformalarrival`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massReopen(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsreopen`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function clearFormalHearingDate(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/clearformalhearing`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function clearFormalArrivalTime(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/clearformalarrival`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function clearInformalHearingDate(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/clearinformalhearing`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function clearInformalArrivalTime(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/clearinformalarrival`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function massGenerateFinalLetters(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/finalletter`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massGenerateFinalLettersStatus(
  { appealsService },
  authenticationToken,
  { massLetterId },
) {
  const url = `${appealsService}/prodigyappeals/appeals/finalletter/${massLetterId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function massGenerateFinalLettersDocuments(
  { appealsService },
  authenticationToken,
  { massLetterId },
) {
  const url = `${appealsService}/prodigyappeals/appeals/finalletter/${massLetterId}/documents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchFinalLetterHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/appeals/finalletter?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassFinalizeHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/massfinalize?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassAppealLetterHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/massgenerateletterhistory?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassProcessEntries(
  { appealsService },
  authenticationToken,
  { process, page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/appeals/massprocess?processName=${process}&page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassProcessDetailList(
  { appealsService },
  authenticationToken,
  { processID },
) {
  const url = `${appealsService}/prodigyappeals/appeals/massprocess/${processID}/list`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createMassProcessEntry(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/massprocess`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassProcessHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/appeal/masscreatelisting?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassAttachHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlogs?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEvidenceUploadHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/appeal/evidenceimports?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEvidenceImportProperties(
  { appealsService },
  authenticationToken,
  { importID, importStatus },
) {
  const url = `${appealsService}/prodigyappeals/appeal/agent/evidenceimport/${importID}/properties?importStatus=${importStatus}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const downloadEvidenceImportFile = async (
  { appealsService },
  authenticationToken,
  { importID },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/agent/evidenceimport/${importID}/downloadfile`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `Evidence Import ${importID}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadEvidenceImportPropertyFile = async (
  { appealsService },
  authenticationToken,
  { pID },
) => {
  const url = `${appealsService}/prodigyappeals/appeal/agent/evidenceimport/property/${pID}/downloadfile`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `Evidence Import Property ${pID}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchMassDownloadHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize, agentName },
) {
  const url = `${appealsService}/prodigyappeals/appeal/massdownloadslisting?page=${page}&pageSize=${pageSize}${
    agentName ? `&agentName=${agentName}` : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassDownloadPropertyHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize, downloadID, agentID, status },
) {
  const url = `${appealsService}/prodigyappeals/appeal/agent/${agentID}/massdownload/${downloadID}/${status}?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassAoaHistory(
  { appealsService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/agentmassaoa?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassAoaHistoryProperties(
  { appealsService },
  authenticationToken,
  { massID },
) {
  const url = `${appealsService}/prodigyappeals/agentmassaoa/${massID}/properties?status=All`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const fetchMassAoaPropertyList = async (
  { appealsService },
  authenticationToken,
  { massAoaID, status },
) => {
  const url = `${appealsService}/prodigyappeals/agentmassaoa/${massAoaID}/properties?status=${status}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function reopenAppeal(
  { appealsService },
  authenticationToken,
  { appealID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/reopen`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function generateFinalLetter(
  { appealsService },
  authenticationToken,
  { appealID, reportName },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/finalletter`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({}),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${reportName}.pdf`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function fetchAutoPacketStatus(
  { appealsService },
  authenticationToken,
  { appealId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/packetgenerationhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function validatePidList(
  { appealsService },
  authenticationToken,
  { pIdList, pYear, skipAllValidations },
) {
  const url = `${appealsService}/prodigyappeals/appeal/validatelist`;
  let payload = { pIDList: pIdList };
  if (pYear) {
    payload.pYear = pYear;
  }
  if (skipAllValidations) {
    payload.skipAllValidations = skipAllValidations;
  }
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function createMassAppealWithAgent(
  { appealsService },
  authenticationToken,
  {
    pYears,
    agentId,
    pIDList,
    appealType,
    appealStatus,
    reasonCodes,
    claimantComments,
    dueDiligenceEvidenceRequest,
    dueDiligenceEvidenceRequestDt,
    filesList,
    hearingTypeRequest,
    hearingTypeNoticePreference,
    hearingReminder,
    hearingReminderFormat,
    specialPanelRequest,
    sameDayHearingRequest,
    sameDayBatch,
    singleMemberPanel,
    informalConferenceRequest,
    email,
    phoneNumber,
  },
) {
  const url = `${appealsService}/prodigyappeals/appeal/agent/${agentId}/masscreateprotest`;
  const { body } = await post(authenticationToken, url, {
    pYears,
    pIDList,
    appealType,
    appealStatus,
    reasonCodes,
    claimantComments,
    dueDiligenceEvidenceRequest,
    dueDiligenceEvidenceRequestDt,
    filesList,
    hearingTypeRequest,
    hearingTypeNoticePreference,
    hearingReminder,
    hearingReminderFormat,
    specialPanelRequest,
    sameDayHearingRequest,
    sameDayBatch,
    singleMemberPanel,
    informalConferenceRequest,
    email,
    phoneNumber,
  });
  return body;
}

export async function createMassAppealWithOwner(
  { appealsService },
  authenticationToken,
  {
    pYears,
    ownerID,
    pIDList,
    appealType,
    appealStatus,
    reasonCodes,
    claimantComments,
    dueDiligenceEvidenceRequest,
    dueDiligenceEvidenceRequestDt,
    filesList,
    hearingTypeRequest,
    hearingTypeNoticePreference,
    hearingReminder,
    hearingReminderFormat,
    specialPanelRequest,
    sameDayHearingRequest,
    sameDayBatch,
    singleMemberPanel,
    informalConferenceRequest,
    email,
    phoneNumber,
  },
) {
  const url = `${appealsService}/prodigyappeals/appeal/owner/${ownerID}/masscreateprotest`;
  const { body } = await post(authenticationToken, url, {
    pYears,
    pIDList,
    appealType,
    appealStatus,
    reasonCodes,
    claimantComments,
    dueDiligenceEvidenceRequest,
    dueDiligenceEvidenceRequestDt,
    filesList,
    hearingTypeRequest,
    hearingTypeNoticePreference,
    hearingReminder,
    hearingReminderFormat,
    specialPanelRequest,
    sameDayHearingRequest,
    sameDayBatch,
    singleMemberPanel,
    informalConferenceRequest,
    email,
    phoneNumber,
  });
  return body;
}

export async function reinitializeAppealSummary(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/reinitialize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massCreateRecommendation(
  { appealsService },
  authenticationToken,
  payload,
) {
  const url = `${appealsService}/prodigyappeals/appeal/masscreaterecommendation`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassCreateRecommendationStatus(
  { appealsService },
  authenticationToken,
  { createId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/masscreate/${createId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealActivityFileLog(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appealactivity/filelogs`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function insertMassAttachLog(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlogs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassAttachLog(
  { appealsService },
  authenticationToken,
  { massAttachLogID },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlog/${massAttachLogID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealActivityFile(
  { appealsService },
  authenticationToken,
  { logID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealactivity/filelog/${logID}`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
}

export async function insertMassAttachLogFile(
  { appealsService },
  authenticationToken,
  { massAttachLogID, payload },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlog/${massAttachLogID}/addfile`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealActivityFile(
  { appealsService },
  authenticationToken,
  { logID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealactivity/filelog/${logID}/removefile`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
}

export async function deleteMassAttachLogFile(
  { appealsService },
  authenticationToken,
  { massAttachLogID, payload },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlog/${massAttachLogID}/removefile`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateMassAttachLog(
  { appealsService },
  authenticationToken,
  { massAttachLogID, payload },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlog/${massAttachLogID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function runMassAttachLog(
  { appealsService },
  authenticationToken,
  { massAttachLogID },
) {
  const url = `${appealsService}/prodigyappeals/massattachdocumentlog/${massAttachLogID}/run`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function massAttachFiles(
  { appealsService },
  authenticationToken,
  { logID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealactivity/${logID}/massattachfiles`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function massDownloadEvidencePackets(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massdownloadevidencepackets`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealMassJob(
  { appealsService },
  authenticationToken,
  { groupID },
) {
  const url = `${appealsService}/prodigyappeals/massjob/${groupID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function downloadMassJobFile(
  { appealsService },
  authenticationToken,
  { groupID, s3ID },
) {
  const url = `${appealsService}/prodigyappeals/massjob/${groupID}/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function fetchAppealEvents(
  { eventService },
  authenticationToken,
  { appealID },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${appealID}`,
    dataObject: 'appeals',
  });
  return body;
}

export const fetchTaxingUnitsSummary = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunitssummary`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchGeneralConfiguration(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/general`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateGeneralConfiguration(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/general`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchRecommendationsConfiguration(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/recommendations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateRecommendationsConfiguration(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/recommendations`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchMassFinalizeConfiguration(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/massfinalize`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateMassFinalizeConfiguration(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/massfinalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAutoGeneratePacketConfiguration(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/autogeneratepacketsubtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAutoGeneratePacketConfiguration(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/autogeneratepacketsubtype`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAutoOfferConfiguration(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/autooffer`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAutoOfferConfiguration(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/autooffer`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealConfigDecisionSheet(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/decisionsheet`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealConfigDecisionSheet(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/decisionsheet`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealConfigRevisionHistory(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appealconfig/revisionhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function setArrivalTime(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/formal/arrival`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function setInformalArrivalTime(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/informal/arrival`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchProtestors(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/protesters`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createProtestor(
  { appealsService },
  authenticationToken,
  { appealID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/protesters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateProtestor(
  { appealsService },
  authenticationToken,
  { protestedByID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/protester/${protestedByID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function setPrimaryProtestor(
  { appealsService },
  authenticationToken,
  { protestedByID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/protester/${protestedByID}/setprimary`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function deleteProtestor(
  { appealsService },
  authenticationToken,
  { protestedByID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/protester/${protestedByID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchProtestorPortalUsers(
  { appealsService },
  authenticationToken,
  { protestedByID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/protester/${protestedByID}/portalusers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsEmails(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/emailaddresses`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchElectronicNoticeSetting(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/configuration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchElectronicNoticeSettingInformalPrior(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/configuration/informalprior`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchElectronicNoticeSettingInformalSameDay(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/configuration/informalsameday`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchElectronicHearingTags(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateElectronicNoticeSetting(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/configuration`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateElectronicNoticeSettingInformalPrior(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/configuration/informalprior`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateElectronicNoticeSettingInformalSameDay(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/configuration/informalsameday`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createElectronicNoticeStartRun(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/electronicdeliverynotice/startrun`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function createMassAoaSubmit(
  { appealsService },
  authenticationToken,
  { agentId, payload },
) {
  const url = `${appealsService}/prodigyappeals/agent/${agentId}/aoa/submit`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function createMassAoaRevoke(
  { appealsService },
  authenticationToken,
  { agentId, payload },
) {
  const url = `${appealsService}/prodigyappeals/agent/${agentId}/aoa/revoke`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function uploadAgentFiles(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/agent/fileupload`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function deletePresentationDocuments(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/presentationdocuments`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPanelDocketGroups(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/docketgroups`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deletePanelDocketGroups(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/docketgroups`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createPanelDocketGroup(
  { appealsService },
  authenticationToken,
  { panelId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/docketgroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deletePanelDocketGroup(
  { appealsService },
  authenticationToken,
  { docketGroupID },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/docketgroup/${docketGroupID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPanelWaitingRooms(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/waitingrooms`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deletePanelWaitingRooms(
  { appealsService },
  authenticationToken,
  { panelId },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/waitingrooms`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function addPanelWaitingRoom(
  { appealsService },
  authenticationToken,
  { panelId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelId}/waitingrooms`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deletePanelWaitingRoom(
  { appealsService },
  authenticationToken,
  { appealPanelWaitingRoomID },
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/waitingroom/${appealPanelWaitingRoomID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchMassProcessPropertyList(
  { appealsService },
  authenticationToken,
  { massCreateID, page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/agent/massprotestlisting/${massCreateID}/properties?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassProcessErrors(
  { appealsService },
  authenticationToken,
  { massCreateID, page, pageSize },
) {
  const url = `${appealsService}/prodigyappeals/agent/massprotestlisting/${massCreateID}/errors?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchFormalVCRecordings(
  { appealsService },
  authenticationToken,
  { appealID },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealID}/formal/vc/recordings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function validateAppealIDsFormalHearing(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/validateappealidlist`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function validatePIDsFormalHearing(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/validatepidlist`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function copyFormalHearingsTo(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/copyformalto`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function copyFormalHearingsFrom(
  { appealsService },
  authenticationToken,
  { appealId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/${appealId}/copyformalfrom`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAgentMassDownloadConfiguration(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeal/agent/massdownloads/configuration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDecisionSheetConfig(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/decisionsheet`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateDecisionSheetConfig(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeals/configuration/decisionsheet`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
